import { useTranslation } from 'react-i18next';
import { InterviewLayout } from '../components/templates/InterviewLayout.js';
import { Typography } from '../components/atoms/Typography.js';
import { Card } from '../components/atoms/Card.js';
import { useInterviewStore } from '../stores/interview-store.js';

function AnimatedCheckmark() {
  return (
    <div className="mb-4 animate-scale-in">
      <svg
        className="mx-auto h-16 w-16 text-success"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" className="opacity-20" fill="currentColor" stroke="none" />
        <path
          d="M7 13l3 3 7-7"
          className="animate-check-draw"
          style={{ strokeDasharray: 24, strokeDashoffset: 24 }}
        />
      </svg>
    </div>
  );
}

export function CompletionPage() {
  const { t } = useTranslation('interview');
  const messages = useInterviewStore((s) => s.messages);
  const userMessages = messages.filter((m) => m.role === 'user');

  return (
    <InterviewLayout title={t('completion.title')}>
      <div className="flex flex-1 flex-col items-center justify-center gap-6">
        <Card padding="lg" className="w-full text-center">
          <AnimatedCheckmark />
          <Typography variant="h2" className="mb-2">
            {t('completion.title')}
          </Typography>
          <Typography variant="body" className="mb-6">
            {t('completion.description')}
          </Typography>
          {userMessages.length > 0 && (
            <Typography variant="body-sm">
              {t('completion.response_count', { count: userMessages.length })}
            </Typography>
          )}
        </Card>
      </div>
    </InterviewLayout>
  );
}
